var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexmarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03 19.703v-4.529H9.566c-.818 0-1.457.2-1.919.6-.455.393-.682.946-.682 1.66 0 .72.227 1.279.682 1.678.455.394 1.095.59 1.919.59h2.462zm-2.122 1.9L6.56 26.5H3.885l3.616-5.23c-.898-.258-1.617-.728-2.158-1.41-.541-.683-.812-1.495-.812-2.436 0-1.26.424-2.28 1.273-3.062.848-.78 1.967-1.17 3.357-1.17h5.23V26.5h-2.362v-4.898H9.91zm7.823 5.09c-.43 0-.784-.138-1.06-.414-.278-.277-.416-.624-.416-1.043 0-.424.138-.771.415-1.042.277-.276.63-.415 1.06-.415.437 0 .79.139 1.061.415.277.27.415.618.415 1.042 0 .419-.138.766-.415 1.043-.27.276-.624.415-1.06.415zm17.073-.193h-2.213v-9.361h-.13l-3.68 8.845h-1.697l-3.68-8.845h-.129V26.5h-2.213V13.191h2.785l4.003 9.693h.166l4.003-9.693h2.785V26.5z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F64A1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexmarket);
export default __webpack_public_path__ + "static/media/yandexmarket.7a4a589dd0d52ffc34dfb246b475f0b8.svg";
export { ForwardRef as ReactComponent };